// ボタン右寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';
var RowRightButton = function (_a) {
    var children = _a.children;
    return (React.createElement(Row, { className: "row-right-button" },
        React.createElement(Col, { xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }),
        React.createElement(Col, { className: "text-right", xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }, children)));
};
export default RowRightButton;
